import React, { useMemo, useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { getBooking } from "../store/slices/booking";
import { Link } from "react-router-dom";

export default function Bookinghistory() {
  const dispatch = useDispatch();

  const {
    data: bookings = [],
    isLoading,
    error,
  } = useSelector((state) => state.booking);

  useEffect(() => {
    dispatch(getBooking({ page: 1, limit: 100 }));
  }, [dispatch]);

  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 10;

  const totalPages = Math.max(1, Math.ceil(bookings.length / PAGE_SIZE));

  const paginatedBookings = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return bookings.slice(start, start + PAGE_SIZE);
  }, [bookings, currentPage]);

  /* ---------- HELPERS ---------- */
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const BookingSkeleton = ({ count = 5 }) => {
    return Array.from({ length: count }).map((_, i) => (
      <article key={i} className="booking-history-card skeleton-card">
        <div className="tourbh-card-main">
          <div className="tourbh-thumb skeleton-box"></div>

          <div className="tourbh-info">
            <div className="skeleton-line skeleton-title"></div>
            <div className="skeleton-line skeleton-subtitle"></div>

            <div className="tourbh-meta">
              <div className="skeleton-line skeleton-meta"></div>
              <div className="skeleton-line skeleton-meta"></div>
              <div className="skeleton-line skeleton-meta"></div>
            </div>

            <div className="skeleton-line skeleton-status"></div>
          </div>
        </div>
      </article>
    ));
  };

  return (
    <>
      <Navbarsticky />
      <div className="bookinghistory-container"></div>

      <Container fluid>
        <div className="booking-history-wrapper w-100">
          <div className="booking-history-shell w-100">
            {/* HEADER */}
            <header className="booking-history-header">
              <div>
                <h2 className="booking-history-title">My Bookings</h2>
              </div>
            </header>

            {/* LIST */}
            <section className="booking-history-list">
              {isLoading ? (
                <BookingSkeleton count={5} />
              ) : error ? (
                <div className="booking-history-empty text-danger">
                  Failed to load bookings
                </div>
              ) : paginatedBookings.length === 0 ? (
                <div className="booking-history-empty">No bookings found</div>
              ) : (
                paginatedBookings.map((b) => (
                  <article key={b.bookingId} className="booking-history-card">
                    <div className="tourbh-card-main">
                      <img
                        src={b.thumbnail?.mediaLink}
                        alt={b.packageName}
                        className="tourbh-thumb"
                      />

                      <div className="tourbh-info">
                        <h4 className="tourbh-title">{b.packageName}</h4>

                        <p className="tourbh-destination">
                          Booking ID: {b.bookingId}
                        </p>

                        <div className="tourbh-meta">
                          <span>🗓&nbsp; {formatDate(b.travelDate)}</span>
                          <span>👥&nbsp; {b.travellers} Travellers</span>
                          <span>⏳&nbsp; {b.durationLabel}</span>
                        </div>

                        <div className="tourbh-meta">
                          <span>
                            💳&nbsp; Payment: <strong>{b.paymentStatus}</strong>
                          </span>
                        </div>

                        <div className="tourbh-actions">
                          {/* <span
                            className={`booking-history-status booking-history-status--${b.status.toLowerCase()}`}
                          >
                            {b.status}
                          </span> */}

                          {b.invoice?.invoiceUrl && (
                            <Link
                              to={b.invoice.invoiceUrl}
                              className="btn btn-primary btn-sm"
                              target="_blank"
                            >
                              Download Invoice
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </article>
                ))
              )}
            </section>

            {/* PAGINATION */}
            <footer className="booking-history-pagination">
              <button
                className="booking-history-page-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                className="booking-history-page-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </footer>
          </div>
        </div>
      </Container>

      <Footer />
    </>
  );
}
